import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSeat = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.00023 2.5C4.00023 1.67157 4.6718 1 5.50023 1C6.32865 1 7.00023 1.67157 7.00023 2.5C7.00023 3.32843 6.32865 4 5.50023 4C4.6718 4 4.00023 3.32843 4.00023 2.5ZM5.00023 2.5C5.00023 2.22386 5.22408 2 5.50023 2C5.77637 2 6.00023 2.22386 6.00023 2.5C6.00023 2.77614 5.77637 3 5.50023 3C5.22408 3 5.00023 2.77614 5.00023 2.5Z'
    />
    <path d='M5.37172 5.01694C5.6386 4.94602 5.91244 5.10487 5.98336 5.37175L7.11461 9.62862C7.17283 9.8477 7.37115 10.0002 7.59783 10.0002L10.5008 10.0002C11.3293 10.0002 12.0009 10.672 12.0008 11.5006L12.0001 14.5004C12.0001 14.7766 11.7762 15.0004 11.5 15.0003C11.2239 15.0003 11.0001 14.7763 11.0001 14.5002L11.0008 11.5003C11.0008 11.2242 10.7769 11.0002 10.5008 11.0002L7.59782 11.0002C6.91777 11.0002 6.32281 10.5427 6.14815 9.88545L5.01691 5.62858C4.94599 5.3617 5.10484 5.08786 5.37172 5.01694Z' />
    <path d='M5.41066 10.8856L4.21438 6.39252L3.24805 6.6498L4.44433 11.1429C4.73585 12.2378 5.72732 12.9998 6.8604 12.9997L10.0004 12.9994L10.0003 11.9994L6.86031 11.9997C6.18046 11.9998 5.58558 11.5426 5.41066 10.8856Z' />
  </svg>
);
export default SvgSeat;
